import React from 'react';
import { useEffect, useState, useRef } from 'react';
import axios from "axios";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import './ChooseTemplate.css';
import Header from '../../../components/Header/header';
import { Button, Col, Row } from "react-bootstrap";
import { Form } from "react-bootstrap";
import Footer from '../../../components/Footer/Footer'
import { FaAngleDown } from "react-icons/fa";
import { FaAngleUp } from "react-icons/fa";
import Loader from '../../../components/Loader/Loader';
import { setTemplateData } from '../../../slices/templateSlice';


const ChooseTemplate = () => {
    const authToken = localStorage.getItem("authToken")
    const [selectedYear, setSelectedYear] = useState("");
    const [availableYears, setAvailableYears] = useState([]);
    // console.log("availableYears",availableYears)
    const [data, SetData] = useState([]);
    // console.log("data", data.length)
    const [isLoadingChoosetemplate, setIsLoadingChoosetemplate] = useState(false);
    const [isError, setIsError] = useState(false);
    const [selectedValue, setSelectedValue] = useState('');
    // const [craeateSelectedValue, setCreateSelectedValue] = useState('');
    const [Alldropdown, setAllDropDown] = useState(false)
    // console.log("All", Alldropdown)
    const [creteDropDown, setCreateDropDown] = useState(false)
    const [checked, setChecked] = useState(false)
    const [deslength, setDesLength] = useState('')
    // console.log("deslength",deslength)
    const [openRowIndex, setOpenRowIndex] = useState(null);
    // console.log("open", openRowIndex)
    const dropDownRef = useRef(null);

    const navigate = useNavigate("/newScreen-templateN")

    const dispatch = useDispatch();

    useEffect(() => {
        dropDownFunction();
    }, []);

    // ✅ Header  Dropdowns Year 

    const dropDownFunction = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_LINK}/api/v1/admin/dropDownArraysForCustomerSummary`,
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            const data = response.data;
            // console.log("data?>>", data)

            if (Array.isArray(data.years) && data.years.length > 0) {
                setAvailableYears(data.years.slice().reverse());
            }
        } catch (error) {
            console.error("Dropdown API error:", error);
        }
    };


    const getFunction = (value, name, index) => {
        // console.log("value",value)
        if (name === "jahrDropdown") {
            setSelectedYear(value);
            setAllDropDown(false);
            // agar same index dubara click hua to close ho jaye
            setOpenRowIndex(openRowIndex === index ? null : index);
        }
    };

    const handleTemplateChange = async (year) => {
        setIsLoadingChoosetemplate(true);
        setIsError(false); // reset
        try {
            let url = `${process.env.REACT_APP_API_LINK}/api/v1/entry/getUniqTempSoldTo`;

            // Agar specific year selected hai tabhi query param add karo
            if (year) {
                url += `?year=${year}`;
            }

            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });
            // console.log("API Response:", response.data.data);
            SetData(response.data.data);
            //  Send API data to Redux
            dispatch(setTemplateData(response.data.data));
        } catch (error) {
            console.error("Error fetching templates:", error);
            setIsError(true); // ❗ error track karo
        } finally {
            setIsLoadingChoosetemplate(false);
        }
    };

    useEffect(() => {
        // if (selectedYear) {
        handleTemplateChange(selectedYear);
        // }
    }, [selectedYear]);

    // useEffect(() => {
    //     handleTemplateChange(selectedValue, selectedYear);
    // }, [selectedYear]);



    const getCustomerIDetail = (row, customerID, division, year, isCopy = false) => {
        // console.log("row",row,customerID,year,division)
        const path = isCopy
            ? `/newScreen-templateN/${customerID}/${division}/${year}_copy`
            : `/newScreen-templateN/${customerID}/${division}/${year}`;
        // return
        navigate(path);
    }

    // const getDropDownList = () => {
    //     const isOpen = !Alldropdown;
    //     setAllDropDown(isOpen);
    //     // if (!isOpen) {
    //     //     setExistDropDown(false);
    //     //     setChooseDropDown(false);
    //     // }
    // };

    // const getCreateDropDownList = () => {
    //     const isOpen = !creteDropDown
    //     setCreateDropDown(isOpen);
    // }


    // All Templates toggle
    const getDropDownList = () => {
        setAllDropDown((prev) => {
            if (!prev) {
                setCreateDropDown(false);
            }
            return !prev;
        });
    };

    // Create Templates toggle
    // const getCreateDropDownList = () => {
    //     setCreateDropDown((prev) => {
    //         if (!prev) {
    //             setAllDropDown(false);
    //         }
    //         return !prev;
    //     });
    // };

    const handleRadioClick = () => {
        const isOpen = !checked
        // console.log(isOpen)
        setChecked(isOpen);
    };


    // ✅ Close dropdown when clicking outside
    useEffect(() => {
        function handleClickOutside(event) {
            if (
                // dropDownRef.current &&
                // !dropDownRef.current.contains(event.target) &&
                // templateRef.current &&
                // !templateRef.current.contains(event.target)
                (dropDownRef.current && !dropDownRef.current.contains(event.target))
            ) {
                setAllDropDown(false);
                // setOpenRowIndex(null);
                // setSelectedYear('');
                // setCreateDropDown(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    // catch variable length
    useEffect(() => {
        if (data && data.length > 0) {
            const firstDescLength = data[0]?.description?.length
            // setDesLength(data[0]?.description?.length)
            setDesLength(firstDescLength)

        }
    }, [data, deslength]);



    const handleDropDownChange = (value) => {
        setSelectedValue(value)
    }

    const handleCreateDropDownChnage = (value) => {
        // setCreateSelectedValue(value)
        // console.log(value)
    }

    const navigateFunction = () => {
        navigate("/newScreen-templateN")
    }


    return (
        <>
            <div className='ChooseTemplate'>
                <div className='chooseTemplate_summary'>
                    <div className="summary_header_main">
                        <Header />
                        <div className="summary_header">
                            <Row className='chooseTemplate_row'>
                                <Col lg={5} md={4} className="user_id_main_chooseTemplate">
                                    <div>
                                        <Form.Label htmlFor="username" className="user_id_text_chooseTemplate">
                                            Jahr
                                        </Form.Label>
                                    </div>
                                    <div className='dropDown_main'>
                                        <div className='dropDown_main' ref={dropDownRef}>
                                            <div className='dropDown_1' onClick={getDropDownList}>
                                                {selectedYear ? selectedYear : "All Jahr"}
                                                <span className="arrow">
                                                    {!Alldropdown ? <FaAngleDown /> : <FaAngleUp />}
                                                </span>
                                            </div>
                                            {Alldropdown ? (
                                                <div className='createTemplateMain'>
                                                    <div className="createDropDownIndex">
                                                        {/* Default option */}
                                                        <div
                                                            // className={openRowIndex === -1 ? "createtemplate_1" : "createtemplate_2"}
                                                            className='createtemplate_2'
                                                            // value="All Jahr"
                                                            onClick={() => getFunction("", "jahrDropdown", -1)}
                                                        >
                                                            All Jahr
                                                        </div>

                                                        {/* Available years */}
                                                        {availableYears.map((item, index) => (
                                                            <div key={index} className="createtemplate_">
                                                                <div
                                                                    // className={openRowIndex === index ? "createtemplate_1" : "createtemplate_2"}
                                                                    className='createtemplate_2'
                                                                    onClick={() => getFunction(item, "jahrDropdown", index)}
                                                                >
                                                                    {item}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                            ) : null}
                                        </div>
                                    </div>
                                </Col>
                                {!isLoadingChoosetemplate && !isError && data?.length === 0 && (
                                    <Col lg={3} md={2} className='user_id_main_chooseTemplate_btn_main' >
                                        <Button onClick={navigateFunction}> Create First Template</Button>
                                    </Col>
                                )}
                            </Row>
                        </div>
                    </div>
                    {/*  */}
                    {isLoadingChoosetemplate ? (
                        <div className="loader_in_chooseTemplate">
                            <Loader />
                        </div>
                    ) : (
                        <div className="chooseTemplate_summary_table_main">
                            {data.length === 0 ? (
                                <div style={{
                                    textAlign: "center",
                                    padding: "10em",
                                    fontWeight: "500",
                                    fontSize: "20px",
                                    color: "gray",
                                    fontStyle: "italic",
                                    height: "75.8vh",
                                }}>
                                    No templates are available at the moment....
                                </div>
                            ) : (

                                <div
                                    // ref={scrollRef}
                                    className="chooseTemplate-table-scroll-container"
                                // onScroll={handleInfinityScroll}
                                >
                                    <table className="choose-template-customer-table">
                                        <thead>
                                            <tr>
                                                {/* <th>S.No</th> */}
                                                <th className='chhosetemplate_tableData'>Jahr</th>
                                                <th className='chhosetemplate_tableData'>Div</th>
                                                <th className='chhosetemplate_tableData'>Kd.nr.</th>
                                                <th className='chhosetemplate_tableData_text'>Beschreibung</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data && data.map((row, index) => (
                                                console.log("description", row.description),
                                                <tr key={index} onClick={() =>
                                                    getCustomerIDetail(index, row.soldTo, row.division, row.planYear, checked ? true : false)
                                                }>
                                                    {/* <td>{index + 1}</td> */}
                                                    <td >
                                                        <div className='chhosetemplate_tableData'>
                                                            {row.planYear}
                                                        </div>
                                                    </td>
                                                    <td >
                                                        <div className='chhosetemplate_tableData'>
                                                            {row.division}
                                                        </div>
                                                    </td>
                                                    <td >
                                                        <div className='chhosetemplate_tableData'>
                                                            {row.soldTo}{checked && "--Copy"}
                                                        </div>
                                                    </td>
                                                    <td className='table_description'>
                                                        <div className='chhosetemplate_tableData_text'>
                                                            {row.description}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    {/* {isLoadingCustDetails && (
                                        <div className="table-loader">
                                            <div className="spinner-border text-secondary" role="status" />
                                        </div>
                                    )} */}
                                </div>
                            )}
                        </div>

                    )}
                </div>
                <Footer className="footer" />
            </div >
        </>
    )
}

export default ChooseTemplate